import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={styles.Footer}>
      <div className={styles.FooterInner}>
        <div className={styles.Column}>
          <h4 className={styles.Title}>Working Evolution S.r.l.</h4>
          <p>Working Evolution S.r.l. P.IVA 06577980821</p>
          <p>REA: PA400790</p>
          <p>Informativa protezione dati</p>
        </div>

        <div className={styles.Column}>
          <h4 className={styles.Title}>Contatti</h4>
          <p>Assistenza: 0915640490</p>
          <p>Commerciale: 3484708155</p>
          <p>Amministrazione: 0917932311</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
